"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const sixteen_nine_iframe_1 = __importDefault(require("./sixteen-nine-iframe"));
const utils_1 = require("../../lib/utils");
const VideoComponent = ({ url, accessibilityText, containerClass, iframeId, testId, allowFullScreen = true }) => {
    const videoUrl = (0, utils_1.getVideoUrl)(url);
    return (react_1.default.createElement(sixteen_nine_iframe_1.default, { src: videoUrl, title: accessibilityText, id: iframeId, containerClass: containerClass, testId: testId, allowFullScreen: allowFullScreen }));
};
exports.default = VideoComponent;
//# sourceMappingURL=video-component.js.map